var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"step-indicator"},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step",class:{
      'active': index === _vm.currentStep,
      'completed': index <= _vm.currentStep
    }},[_c('div',{staticClass:"circle"},[_vm._v(_vm._s(index + 1))]),_c('div',{staticClass:"label"},[_vm._v(_vm._s(step))]),(index < _vm.steps.length -1 )?_c('div',{staticClass:"line"}):_vm._e()])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }